import { sakiraCaseStudy } from './sakiraCaseStudy'
import { anim8ContentAboutMedia } from './anim8ContentStats'

export const caseStudies = {
  'anim-8': {
    responsibilities: [],
    roleBody: [
      'I own the technical and visual execution across the projects: Unreal pipeline, tools, camera layout, lighting, and final rendering. I work from the director\'s vision and translate it into shots, run quality control across the animation team, and make the call when he\'s not available. When something breaks or a shot isn\'t landing, I\'m the one who solves it.',
    ],
    breakdownSectionTitle: 'Animation → Unreal Import Pipeline',
    breakdownTitle: 'Technical Breakdown',
    breakdownIntro:
      'Built an Unreal Editor plugin that organizes Maya-exported FBX/Alembic from Staging into shot folders and auto-builds Level Sequences. per-shot anim, cache, and camera tracks, lighting sequences, and a master sequence. so the team can go from export to Sequencer without hand-wiring each shot.',
    breakdown: [
      'Packaged as an Editor Utility Widget plugin installable across Anim-8 Unreal projects',
      'Defined Maya/Unreal naming conventions (Shot##_) so assets route and bind automatically',
      'Organized Staging imports into /Game/Production/{Project}/Shot##/ and shared character/prop folders',
      'Built per-shot Level Sequences with animation, geometry cache, and camera cut tracks',
      'Generated empty lighting sequences per shot and a master sequence with shots in order',
      'Adds a freeze frame at the start of each sequence for rendering with subsequence lighting',
      'Added a Social Media filmback preset for cine cameras tailored to vertical social framing',
      'Built a Movie Render Queue button that populates MRQ with all shots in a project',
    ],
    breakdownMedia: {
      id: 'anim8-pipeline-overview',
      label: 'Anim 8 scripting pipeline overview',
      video: '/videos/anim8-pipeline-overview.mp4',
    },
    contentSectionTitle: 'About Anim 8',
    contentTitle: 'Anim 8 Content',
    contentAbout: [
      'Anim8 is a 15-person 3D animation and design studio based in Saigon, Vietnam.',
    ],
    contentShowSocialStats: true,
    contentAboutMedia: anim8ContentAboutMedia,
    contentMedia: [
      {
        id: 'anim8-song-coffee-monster-fight',
        label: 'Coffee Monster Fight',
        tiktokId: '7667626276076735774',
        poster: '/images/anim8-song-coffee-monster-fight.jpg',
        isShort: true,
      },
      {
        id: 'anim8-song-coffee-backrooms',
        label: 'Coffee Backrooms',
        tiktokId: '7600538917124771103',
        poster: '/images/anim8-song-coffee-backrooms.jpg',
        isShort: true,
      },
      {
        id: 'anim8-song-the-brew',
        label: 'The Brew',
        tiktokId: '7616092975407418655',
        poster: '/images/anim8-song-the-brew.jpg',
        isShort: true,
      },
      {
        id: 'anim8-song-skate-night',
        label: 'Song Skate Night/Day',
        tiktokId: '7622062811287489822',
        poster: '/images/anim8-song-skate-night.jpg',
        isShort: true,
      },
      {
        id: 'anim8-song-finding-kiiboh',
        label: 'Finding Kiiboh',
        tiktokId: '7640199861098286366',
        poster: '/images/anim8-song-finding-kiiboh.jpg',
        isShort: true,
      },
      {
        id: 'anim8-song-caffeine-overload',
        label: 'Song Caffeine Overload',
        tiktokId: '7646908771347860766',
        poster: '/images/anim8-song-crazy.jpg',
        isShort: true,
      },
      {
        id: 'anim8-song-phin-introduction',
        label: 'Phin Introduction',
        video: '/videos/anim8-song-phin-introduction.mp4',
        poster: '/images/anim8-song-phin-introduction.jpg',
        isShort: true,
      },
    ],
    detailSections: [
      {
        id: 'lighting',
        title: 'Lighting',
        body: [
          'Went with Lumen over the path tracer. Real-time GI meant I could iterate on the look live in-editor, which mattered more here than the accuracy I\'d have gained.',
          'The whole scene is a dream, so it\'s lit bright and high-energy. but on a neutral, grimy palette instead of the clean ethereal look dreams usually get. Shadows are soft across the level, which pulls the falloff toward Pixar/anime and away from photoreal. Magical, but still dirty.',
          'Ray traced shadows killed the volumetric fog. RT lights don\'t get injected into the fog grid by default. r.VolumetricFog.InjectRaytracedLights 1 brought it back.',
          'Lighting is per-scene in its own Level Sequence, assets foldered by shot. Look developed with the creative director on [project].',
        ],
        media: [
          {
            id: 'anim8-lighting-breakdown',
            label: 'Lighting breakdown',
            video: '/videos/anim8-lighting-breakdown.mp4',
            poster: '/images/anim8-lighting-breakdown.jpg',
            isShort: false,
          },
        ],
      },
      {
        id: 'cloth-sim',
        title: 'Cloth Sim',
        body: [
          'Shirt and pants are separate Chaos Cloth Assets instead of cloth painted onto the skeletal mesh. Each cloth runs on its own sim mesh with skin weights transferred from the body. I painted Max Distance to decide what stays pinned and what swings, also created a collision selection set against the body, and set up self-collision with friction and thickness weight maps.',
          'It\'s not perfect. Fast leg motion still pokes through the pants now and then. I\'m holding it back with sub step count and tighter Max Distance around the knee. a velocity-driven constraint pass is the actual fix, and that\'s next.',
        ],
        media: {
          id: 'anim8-cloth-sim',
          label: 'Cloth Sim Breakdown',
          video: '/videos/anim8-cloth-sim.mp4',
          poster: '/images/anim8-cloth-sim.jpg',
          isShort: false,
        },
      },
    ],
  },
  'sakira-mods': sakiraCaseStudy,
}
